var _rect, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrepaidCongif(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 5,
    fill: "url(#paint0_linear_224_758)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6523 27.4219H14.3477C13.3984 27.4219 12.6289 28.1914 12.6289 29.1406V29.3555C12.6289 29.7114 12.9175 30 13.2734 30H22.7266C23.0825 30 23.3711 29.7114 23.3711 29.3555V29.1406C23.3711 28.1914 22.6016 27.4219 21.6523 27.4219Z",
    fill: "url(#paint1_linear_224_758)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22.3945C7 23.6976 8.06017 24.7578 9.36328 24.7578H14.5739L14.192 26.1328H21.8081L21.4261 24.7578H26.6367C27.9398 24.7578 29 23.6976 29 22.3945V22.1797H7V22.3945Z",
    fill: "url(#paint2_linear_224_758)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8672 12.5117C20.801 12.5117 19.9336 13.3791 19.9336 14.4453C19.9336 15.5115 20.801 16.3789 21.8672 16.3789C22.9334 16.3789 23.8008 15.5115 23.8008 14.4453C23.8008 13.3791 22.9334 12.5117 21.8672 12.5117ZM21.8672 15.0898C21.5112 15.0898 21.2227 14.8013 21.2227 14.4453C21.2227 14.0894 21.5112 13.8008 21.8672 13.8008C22.2231 13.8008 22.5117 14.0894 22.5117 14.4453C22.5117 14.8013 22.2231 15.0898 21.8672 15.0898Z",
    fill: "url(#paint3_linear_224_758)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6367 8H9.36328C8.06017 8 7 9.06017 7 10.3633V20.8906H29V10.3633C29 9.06017 27.9398 8 26.6367 8ZM15.4219 18.3125H12.1992C12.1992 18.6685 11.9106 18.957 11.5547 18.957C11.1987 18.957 10.9102 18.6685 10.9102 18.3125H10.2656C9.90967 18.3125 9.62109 18.0239 9.62109 17.668C9.62109 17.312 9.90967 17.0234 10.2656 17.0234H10.9102C10.9102 16.6675 11.1987 16.3789 11.5547 16.3789C11.9106 16.3789 12.1992 16.6675 12.1992 17.0234H15.4219C15.7778 17.0234 16.0664 17.312 16.0664 17.668C16.0664 18.0239 15.7778 18.3125 15.4219 18.3125ZM15.4219 15.0898H14.7773C14.7773 15.4458 14.4888 15.7344 14.1328 15.7344C13.7769 15.7344 13.4883 15.4458 13.4883 15.0898H10.2656C9.90967 15.0898 9.62109 14.8013 9.62109 14.4453C9.62109 14.0894 9.90967 13.8008 10.2656 13.8008H13.4883C13.4883 13.4448 13.7769 13.1562 14.1328 13.1562C14.4888 13.1562 14.7773 13.4448 14.7773 13.8008H15.4219C15.7778 13.8008 16.0664 14.0894 16.0664 14.4453C16.0664 14.8013 15.7778 15.0898 15.4219 15.0898ZM15.4219 11.8672H12.1992C12.1992 12.2231 11.9106 12.5117 11.5547 12.5117C11.1987 12.5117 10.9102 12.2231 10.9102 11.8672H10.2656C9.90967 11.8672 9.62109 11.5786 9.62109 11.2227C9.62109 10.8667 9.90967 10.5781 10.2656 10.5781H10.9102C10.9102 10.2222 11.1987 9.93359 11.5547 9.93359C11.9106 9.93359 12.1992 10.2222 12.1992 10.5781H15.4219C15.7778 10.5781 16.0664 10.8667 16.0664 11.2227C16.0664 11.5786 15.7778 11.8672 15.4219 11.8672ZM26.3789 14.4453C26.3789 14.8013 26.0903 15.0898 25.7344 15.0898H25.025C24.9413 15.5007 24.7787 15.883 24.5546 16.2212L25.0575 16.7241C25.3092 16.9758 25.3092 17.3839 25.0575 17.6356C24.8058 17.8873 24.3977 17.8873 24.146 17.6356L23.6431 17.1327C23.305 17.3569 22.9226 17.5194 22.5118 17.6031V18.3125C22.5118 18.6685 22.2232 18.957 21.8672 18.957C21.5113 18.957 21.2227 18.6685 21.2227 18.3125V17.6031C20.8119 17.5194 20.4295 17.3568 20.0914 17.1327L19.5885 17.6356C19.3368 17.8873 18.9287 17.8873 18.677 17.6356C18.4253 17.3839 18.4253 16.9758 18.677 16.7241L19.1799 16.2212C18.9557 15.883 18.7932 15.5007 18.7095 15.0898H18C17.644 15.0898 17.3555 14.8012 17.3555 14.4453C17.3555 14.0893 17.644 13.8007 18 13.8007H18.7094C18.7931 13.3899 18.9556 13.0075 19.1798 12.6694L18.6769 12.1665C18.4252 11.9148 18.4252 11.5067 18.6769 11.255C18.9286 11.0033 19.3367 11.0033 19.5884 11.255L20.0913 11.7579C20.4294 11.5337 20.8118 11.3712 21.2226 11.2875V10.5781C21.2226 10.2222 21.5112 9.93359 21.8671 9.93359C22.2231 9.93359 22.5117 10.2222 22.5117 10.5781V11.2875C22.9225 11.3712 23.3049 11.5338 23.643 11.758L24.1459 11.2551C24.3976 11.0034 24.8057 11.0034 25.0574 11.2551C25.3091 11.5068 25.3091 11.9148 25.0574 12.1666L24.5545 12.6695C24.7787 13.0076 24.9412 13.39 25.0249 13.8008H25.7344C26.0903 13.8008 26.3789 14.0894 26.3789 14.4453Z",
    fill: "url(#paint4_linear_224_758)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_758",
    x1: 0,
    y1: 0,
    x2: 37,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F80ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CCF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_224_758",
    x1: 22.6095,
    y1: 27.8874,
    x2: 10.848,
    y2: 29.4852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_224_758",
    x1: 27.4402,
    y1: 22.8935,
    x2: 3.69021,
    y2: 27.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_224_758",
    x1: 23.5266,
    y1: 13.2101,
    x2: 19.2189,
    y2: 13.3505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_224_758",
    x1: 27.4402,
    y1: 10.3278,
    x2: 2.98398,
    y2: 11.6887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepaidCongif);
export default __webpack_public_path__ + "static/media/prepaid-congif.9d98f22638c29a7773bc7882fec9848b.svg";
export { ForwardRef as ReactComponent };